// Which build variant this page is running. The public game (/play) and the marketing
// landing (/) are 'base'; the hidden kids' variant (/hidden) sets window.__variant before
// the module loads (see hidden.html), swapping in a custom ability roster. Resolved once at
// module load - the flag must be set by an inline script in <head> before main.ts runs.

declare global {
  interface Window {
    __variant?: string;
  }
}

export type Variant = 'base' | 'hidden';

export const VARIANT: Variant =
  typeof window !== 'undefined' && window.__variant === 'hidden' ? 'hidden' : 'base';
